import { useContext, useSyncExternalStore } from 'react';
import { FloatingActionsContext } from './FloatingActionsContext';

function useFloatingActionsStore() {
    const store = useContext(FloatingActionsContext);
    if (store === null) {
        throw new Error('FloatingActionDock debe usarse dentro de FloatingActionsProvider.');
    }

    return store;
}

export function FloatingActionDock() {
    const store = useFloatingActionsStore();
    const actions = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getServerSnapshot);

    if (actions.length === 0) {
        return null;
    }

    return (
        <div
            className="pointer-events-none fixed right-[calc(1rem+var(--spacing-safe-right,0px))] z-[960] flex max-w-[calc(100vw-2rem-var(--spacing-safe-left,0px)-var(--spacing-safe-right,0px))] flex-col items-end gap-3"
            style={{
                bottom: 'calc(var(--bottom-nav-height) + var(--spacing-safe-bottom, 0px) + 4.75rem)',
            }}
            role="group"
            aria-label="Acciones flotantes"
        >
            {actions.map((action) => (
                <div key={action.id} className="pointer-events-auto max-w-full" data-floating-action-id={action.id}>
                    {action.content}
                </div>
            ))}
        </div>
    );
}
